<template>
	<!-- <div class="report-side-panel bench-overview-side-panel q-box-shadow fromleft"> -->
	<div class="lft-view report-side-panel customer-engagement q-box-shadow">
		<report-header @updateEvent="updateWorkloadData" @downloadEvent="exportExcel"></report-header>
		<!-- table set -->
		<div class="table-wrapper" ref="tableWrapperLap">
			<div class="master-table-head-box">
				<div class="master-table-head consultant-workload">
					<div class="consultant-w dropdown-setter left-pos-cell" data-setter="consultant">
						<div class="master-table-text left-table-header" @click="sortTable('consultant')">Consultant</div>
						<div class="master-table-opt"></div>
						<button type="button" class="vs-con-dropdown parent-dropdown" data-getter="consultant">
							<a href.prevent class="a-icon">
								<!-- <i class="filter-icon-i"></i> -->
								<i :class="(consultantSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
							</a>
						</button>
						<Dropdown>
							<ul>
								<li>
									<input
										oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
										type="text"
										class="dropdown-input"
										placeholder="Filter"
										v-model="consultantSearch"
									/>
								</li>
							</ul>
						</Dropdown>
					</div>
					<div class="co-w-thone-sap dropdown-setter" data-setter="sapno">
						<div
							class="master-table-text left-table-header"
							@click="sortTable('sap_no')"
							data-setter="sapno"
						>SAP no</div>
						<div class="master-table-opt"></div>
						<button type="button" class="vs-con-dropdown parent-dropdown" data-getter="sapno">
							<a href.prevent class="a-icon">
								<!-- <i class="filter-icon-i"></i> -->
								<i :class="(sapSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
							</a>
						</button>
						<Dropdown>
							<ul>
								<li>
									<input
										oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
										type="text"
										class="dropdown-input"
										placeholder="Filter"
										v-model="sapSearch"
										:class="{'error-border':searchError.sap_no}"
									/>
								</li>
							</ul>
						</Dropdown>
					</div>
					<div class="co-w-thone-country dropdown-setter" data-setter="country">
						<div class="master-table-text left-table-header" @click="sortTable('country')">Country</div>
						<div class="master-table-opt"></div>
						<button type="button" class="vs-con-dropdown parent-dropdown" data-getter="country">
							<a href.prevent class="a-icon">
								<!-- <i class="filter-icon-i"></i> -->
								<i :class="(countrySearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
							</a>
						</button>
						<Dropdown>
							<ul>
								<li>
									<input
										oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
										type="text"
										class="dropdown-input"
										placeholder="Filter"
										v-model="countrySearch"
									/>
								</li>
							</ul>
						</Dropdown>
					</div>
					<div class="co-w-thone dropdown-setter right-pos-cell" data-setter="oe">
						<div class="master-table-text left-table-header" @click="sortTable('oe')">OE</div>
						<div class="master-table-opt"></div>
						<button type="button" class="vs-con-dropdown parent-dropdown" data-getter="oe">
							<a href.prevent class="a-icon">
								<!-- <i class="filter-icon-i"></i> -->
								<i :class="(oeSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
							</a>
						</button>
						<Dropdown>
							<ul>
								<li>
									<input
										oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
										type="text"
										class="dropdown-input"
										placeholder="Filter"
										v-model="oeSearch"
									/>
								</li>
							</ul>
						</Dropdown>
					</div>
				</div>
			</div>
			<div class="master-table vb" v-bar :class="loaderClass">
				<scroll-sync group="one" ref="verticalscrollset" vertical>
					<scroll-sync group="two" vertical>
						<!-- add here -->
						<template v-for="(relation, index) in relations">
							<div class="report-left-list consultant-workload" :key="index" ref="consultantRelationRow">
								<div class="each-turn consultant-w">
									<div class="master-table-text right-table-header alloc-value">
										<p class="left-td">{{relation.fullName}}</p>
									</div>
								</div>
								<div class="each-turn co-w-thone-sap">
									<div class="master-table-text right-table-header alloc-value">
										<p class="left-td">{{relation.sap}}</p>
									</div>
								</div>
								<div class="each-turn co-w-thone-country">
									<div class="master-table-text right-table-header alloc-value">
										<p class="left-td">{{relation.country}}</p>
									</div>
								</div>
								<div class="each-turn co-w-thone">
									<div class="master-table-text right-table-header alloc-value">
										<p class="left-td">{{relation.oeShortName}}</p>
									</div>
								</div>
							</div>
						</template>
						<div class="no-item" v-if="relations.length < 1">No items found !</div>
					</scroll-sync>
				</scroll-sync>
			</div>
		</div>

		<!-- bottom -->
		<div class="table-results">
			<div class="table-result">
				<p class="left-td bottom-left-heading">Internal Consultants</p>
			</div>
			<div class="table-result">
				<p class="left-td bottom-left-heading">External Consultants</p>
			</div>
			<div class="table-result">
				<p class="left-td bottom-left-heading">Total</p>
			</div>
		</div>
	</div>
</template>

<script>
    const ReportHeader = () => import("../ReportHeader");
    const Dropdown = () => import("../../../common/Dropdown");

    import settings from "../../../../config/settings";
    import searchKeys from "../../../../config/searchKeys";
    import _ from "lodash";

    export default {
        name: "ConsultantworkloadRelation",
        data() {
            return {
                masterTableWidth: 0,
                loadMore: true,
                loaderClass: "",
                searchError: {
                    sap_no: false
                }
            };
        },
        components: {
            ReportHeader,
            Dropdown
        },
        computed: {
            /**
             * Bench report cosultant list from store
             */
            relations: function () {
                return this.$store.state.reports.consultantWorkloadRelations;
            },
            /**
             * Get the bench overview filter data from store
             */
            filter: function () {
                return this.$store.state.reports.consultantWorkloadFilter;
            },
            /**
             * if loading more rows for bench overview
             */
            isLoadingMoreRows: function () {
                return this.$store.state.reports.loadingCustomerEngagementRows;
            },
            /**
             * Model binding for consultant search
             */
            consultantSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.consultantWorkloadFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(
                        f => f.fieldName === searchKeys.consultant
                    );
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : "";
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.consultant,
                        value: value
                    };
                    this.$store.commit("setConsultantWorkloadSearchData", data);
                }
            },
            /**
             * Model binding for sap number search
             */
            sapSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.consultantWorkloadFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(
                        f => f.fieldName === searchKeys.sap_no
                    );
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : "";
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.sap_no,
                        value: value
                    };
                    this.$store.commit("setConsultantWorkloadSearchData", data);
                }
            },
            /**
             * Model binding for country search
             */
            countrySearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.consultantWorkloadFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(
                        f => f.fieldName === searchKeys.country
                    );
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : "";
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.country,
                        value: value
                    };
                    this.$store.commit("setConsultantWorkloadSearchData", data);
                }
            },
            /**
             * Model binding for OE search
             */
            oeSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.consultantWorkloadFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(
                        f => f.fieldName === searchKeys.oe
                    );
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : "";
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.oe,
                        value: value
                    };
                    this.$store.commit("setConsultantWorkloadSearchData", data);
                }
            }
        },
        methods: {
            /**
             * set the table width
             */
            setTableWidth: function () {
                setTimeout(() => {
                    let element = document.querySelector(
                        ".report-allocations .gm-scroll-view"
                    );
                    if (element) {
                        this.masterTableWidth = element.scrollWidth;
                    }
                }, 200);
            },
            /**
             * Load more report data
             */
            loadMoreResults: function () {
                if (this.loadMore) {
                    this.loadMore = false;
                    this.$store.dispatch("fetchMoreBenchReport").then(() => {
                        this.loadMore = true;
                    });
                }
            },
            /**
             * Request with the search result once the user stopped typing
             */
            submitSearchResult: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize = settings.initial_forecast_row_count;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    // fetch the bench report with the search data
                    this.$store.dispatch("fetchConsultantWorkload", filter);
                    this.$store.dispatch("fetchConsultantWorkloadAggregate", filter);
                }, 700);
            },
            /**
             * Sort the table on click
             */
            sortTable: function (column) {
                let rowCount = settings.initial_forecast_row_count;
                //clone the filter
                let filter = this.filter;
                let filterData = _.cloneDeep(filter);
                // if no sort set or sort set for another column
                if (!filter.sortColumn || filter.sortColumn !== searchKeys[column]) {
                    this.$store.commit("setConsultantWorkloadSearch", {
                        column: searchKeys[column],
                        order: "ASC"
                    });
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'ASC';
                } else if (
                    filter.sortColumn === searchKeys[column] &&
                    filter.sortOrder === "ASC"
                ) {
                    this.$store.commit("setConsultantWorkloadSearch", {
                        column: searchKeys[column],
                        order: "DESC"
                    });
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'DESC';
                } else if (
                    filter.sortColumn === searchKeys[column] &&
                    filter.sortOrder === "DESC"
                ) {
                    this.$store.commit("setConsultantWorkloadSearch", {
                        column: searchKeys[column],
                        order: "ASC"
                    });
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'ASC';
                }
                if (this.relations && this.relations.length) {
                    rowCount = this.relations.length;
                }
                // set row count
                filterData.pageSize = rowCount;
                // set the page number to 1
                filterData.pageNumber = 1;
                // request data with filter
                this.$store.dispatch("fetchConsultantWorkload", filterData);
            },

            /**
             * Mouse wheel on right table should scroll the horizontal area.
             * @constructor
             */
            HeadHorizontalScroll: function () {
                let ScrollElement = this.$refs.masterHeadScroll,
                    scrollableElement = document.querySelector(
                        ".report-alloc-benchoverview .gm-scroll-view"
                    ),
                    i = 0;

                //Mouse wheel and scroll event
                ScrollElement.addEventListener("wheel", function (e) {
                    //When dragging to left side
                    if (e.deltaY < 0 && !e.shiftKey) {
                        if (i >= 0) {
                            //if Scroll left == 0
                            scrollableElement.scrollLeft = i;
                            i = i - 50;
                        } else {
                            i = 0;
                        }
                    }
                    //Mouse wheel and horizontal scroll for allocation's headers
                    else if (e.deltaY > 0 && !e.shiftKey) {
                        if (i <= scrollableElement.scrollWidth) {
                            //if Scroll left !== end of the div
                            scrollableElement.scrollLeft = i;
                            i = i + 50;
                        } else {
                            i = scrollableElement.scrollWidth;
                        }
                    }
                });
            },
            updateWorkloadData: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize = this.relations.length || 25;
                this.$store.dispatch("fetchConsultantWorkload", filter);
                this.$store.dispatch("fetchConsultantWorkloadAggregate", filter);
            },
            exportExcel: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize = this.relations.length || 25;
                // send request
                this.$store.dispatch("exportConsultantworkload", filter);
            },
            updateLoader: function () {
                setTimeout(() => {
                    if (typeof this.$refs.consultantRelationRow !== "undefined") {
                        this.loaderClass = "master-table-loaded";
                    }
                }, 200);
            },
            
            

            wrappingLap: function(){
                // this.$refs.table-wrapper-lap
                var el = this.$refs.tableWrapperLap;
                if(!el.closest('.table-wrapper-outer')){
                    
                    var wrapper = document.createElement('div');
                    wrapper.classList.add('table-wrapper-outer');
                    el.parentNode.insertBefore(wrapper, el);
                    wrapper.appendChild(el);
                }
            }
        },
        updated() {
            this.setTableWidth();
            this.updateLoader();
        },
        created() {
            this.updateLoader();
        },
        
        mounted(){
            this.wrappingLap();
        },
        watch: {
            allocations: function () {
                this.setTableWidth();
            },
            consultantSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            },
            countrySearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            },
            sapSearch: function (value) {
                if (!value || /^(\d)+(.\d+)?$/.test(value)) {
                    this.searchError.sap_no = false;
                    this.submitSearchResult();
                } else this.searchError.sap_no = !!value;
            },
            customerSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            },
            oeSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            },
            engagementSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            }
        }
    };
</script>

<style scoped>
	.scroll-sync-container.vb-content {
		border-bottom: 1px solid #dee1e3;
	}

	/* Header cols */
	.customer-engagement {
		width: 1015px;
	}

	@media screen and (min-width: 1560px) {
		.customer-engagement {
			min-width: 1015px;
		}
	}

	.customer-field {
		width: 163px;
		min-width: 163px;
		padding-left: 43px;
	}

	.consultant-field {
		width: 122px;
		min-width: 122px;
	}

	.project-field {
		width: 96px;
		min-width: 96px;
	}

	.country-field {
		width: 101px;
		min-width: 101px;
	}

	.oe-field {
		width: 90px;
		min-width: 90px;
	}

	.level-field {
		width: 82px;
		min-width: 82px;
	}

	.start-field {
		width: 82px;
		min-width: 82px;
	}

	.end-field {
		width: 82px;
		min-width: 82px;
	}

	.hrrate-field {
		width: 94px;
		min-width: 94px;
	}

	.timeleft-field {
		width: 103px;
		min-width: 103px;
	}

	/* Layout */
	.report-side-panel {
		min-width: 423px;
		width: 423px;
	}

	.table-results {
		padding-top: 16px;
	}

	.error-border {
		border: 1px solid red;
	}

	.master-table {
		max-height: calc(100vh - 310px);
		min-height: calc(100vh - 310px);
		height: calc(100vh - 310px);
	}

	.month-report-bottom {
		height: 100%;
	}
    .each-turn{
        height: 26px !important;
    }
</style>